export default __webpack_public_path__ + "static/media/MR.13873d0c.svg";